import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "./i18n/I18nContext";
import { AuthProvider } from "./context/AuthContext";
import { ProfileProvider } from "./context/ProfileContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Meals from "./pages/Meals";
import Glucose from "./pages/Glucose";
import Analysis from "./pages/Analysis";
import Doses from "./pages/Doses";
import History from "./pages/History";
import HealthRecord from "./pages/HealthRecord";
import Family from "./pages/Family";
import Settings from "./pages/Settings";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <ProfileProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/onboarding" element={<Onboarding />} />

              <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="refeicoes" element={<Meals />} />
                <Route path="glicemia" element={<Glucose />} />
                <Route path="analise" element={<Analysis />} />
                <Route path="doses" element={<Doses />} />
                <Route path="historico" element={<History />} />
                <Route path="ficha" element={<HealthRecord />} />
                <Route path="familia" element={<Family />} />
                <Route path="definicoes" element={<Settings />} />
              </Route>

              <Route path="/" element={<Navigate to="/app" replace />} />
              <Route path="*" element={<Navigate to="/app" replace />} />
            </Routes>
          </BrowserRouter>
        </ProfileProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
